import React from 'react';
import { Table, Tag } from 'antd';
import dayjs from 'dayjs';
import { usePendingAudit } from '../../hooks/useStudioOps';

const BOX_STATUS = {
    900: 'Legacy closed',
    1000: 'Open',
    2000: 'Pending audit',
    2100: 'Audit in progress',
    2200: 'Audit failed',
    2300: 'Pending approval',
    3000: 'Audited',
    4000: 'Outbounded',
};

function formatDate(value) {
    return value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '';
}

const boxColumns = [
    { title: 'Box', dataIndex: 'boxId' },
    { title: 'Items', render: (_, row) => (row.skuIds || []).length },
    { title: 'Closed at', dataIndex: 'closedAt', render: formatDate },
    { title: 'Status', dataIndex: 'status', render: s => BOX_STATUS[s] || s },
    {
        title: 'Reshoot',
        render: (_, row) => ((row.reshootFlagged || []).length ? <Tag color="red">Yes</Tag> : 'No'),
    },
];

export default function PendingAudit() {
    const { data, isFetching } = usePendingAudit({ pageNum: 1, pageSize: 500 });
    const companies = data?.data?.byCompany || [];

    return (
        <div style={{ padding: 16 }}>
            <Table
                loading={isFetching}
                rowKey="companyCode"
                dataSource={companies}
                pagination={false}
                columns={[
                    { title: 'Client', dataIndex: 'companyCode' },
                    { title: 'Boxes', dataIndex: 'boxes' },
                    { title: 'Items', dataIndex: 'items' },
                    { title: 'In progress', dataIndex: 'inProgress' },
                    { title: 'Reshoot boxes', dataIndex: 'reshootBoxes' },
                    { title: 'Oldest closed', dataIndex: 'oldestClosedAt', render: formatDate },
                ]}
                expandable={{
                    expandedRowRender: company => (
                        <Table
                            size="small"
                            pagination={false}
                            rowKey="_id"
                            dataSource={company.list || []}
                            columns={boxColumns}
                        />
                    ),
                }}
            />
        </div>
    );
}
